import { SVGIconComponent } from './types';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const LockerEnabled: SVGIconComponent = ({ className, color, style }) => (
  <CheckCircleIcon
    style={{
      color: color ?? '#848484',
      fontSize: '24px',
      ...style
    }}
    className={className}
  ></CheckCircleIcon>
);
